export default __webpack_public_path__ + "static/media/refyne-logo.cc0e8d3a.svg";